export class GameData {
    static DataTicker: string = "TICKER";
    static DataRoundId: string = "ROUND_ID";
    static DataBuildVersion: string = "BUILD_VERSION";
    static DataBalanceReal: string = "BALANCE_REAL";
    static DataBalanceBonus: string = "BALANCE_BONUS";
    static DataBalanceTotal: string = "BALANCE_TOTAL";
    static DataBalanceRealDenom: string = "BALANCE_REAL_DENOM";
    static DataBalanceBonusDenom: string = "BALANCE_BONUS_DENOM";
    static DataBalanceTotalDenom: string = "BALANCE_TOTAL_DENOM";
    static DataCurrency: string = "CURRENCY";
    static DataDenomination: string = "DENOMINATION";
    static DataCurrentWin: string = "CURRENT_WIN";
    static DataTotalWin: string = "TOTAL_WIN";
    static DataTotalWinDenom: string = "TOTAL_WIN_DENOM";
    static DataCoinSize: string = "COIN_SIZE";
    static DataCointCount: string = "COIN_COUNT";
    static DataPaylineCount: string = "PAYLINE_COUNT";
    static DataBet: string = "BET";
    static DataBetPosition: string = "BET_POSITION";
    static DataGambleCurrentWin: string = "GAMBLE_WIN";
    static DataGambleColorWin: string = "GAMBLE_COLOR_WIN";
    static DataGambleCurrentWinDenom: string = "GAMBLE_WIN_DENOM";
    static DataGambleColorWinDenom: string = "GAMBLE_COLOR_WIN_DENOM";
    static DataAutoplayCount: string = "AUTOPLAY_COUNT";
    static DataFreeSpinTotalWin: string = "FREESPIN_TOTAL_WIN";
    static DataFreeSpinTotalWinDenom: string = "FREESPIN_TOTAL_WIN_DENOM";
    static DataFreeSpinsCount: string = "FREESPINS_COUNT";
    static DataFreeSpinsRemainingCount: string = "FREESPINS_REMAINING_COUNT";
    static DataFreeSpinsWonCount: string = "FREESPINS_WON_COUNT";
    static DataGambleAttempts: string = "GAMBLE_ATTEMPTS";
    static DataHelpGameLimit: string = "HELP_GAME_LIMIT";
    static DataHelpGambleLimit: string = "HELP_GAMBLE_LIMIT";
    static DataHelpGambleCountLimit: string = "HELP_GAMBLE_COUNT_LIMIT";
    static DataHelpRTP: string = "HELP_RTP";
    static DataHelpMaxPayoutProbability: string = "HELP_MAX_PAYOUT_PROBABILITY";
    static DataHelpMaxPayoutFrequency: string = "HELP_MAX_PAYOUT_FREQUENCY";
    static DataHelpMinBet: string = "HELP_MIN_BET";
    static DataHelpMaxBet: string = "HELP_MAX_BET";
    static DataHelpVersion: string = "HELP_VERSION";
    static DataExpirationResolveHours: string = "EXPIRATION_RESOLVE_HOURS";
    static DataFrbRemainginCount: string = "FRB_REMAINING_COUNT";
    static DataFrbAssignedCount: string = "FRB_ASSIGNED_COUNT";
    static DataFrbRulesLink: string = "FRB_RULES_LINK";
    static DataFrbValidTo: string = "FRB_VALID_TO";
    static DataFrbExpiryTime: string = "FRB_EXPIRY_TIME";
    static DataFrbWin: string = "FRB_WIN";
    static DataGameTitle: string = "GAME_TITLE";
    static DataHelpJackpotVisibleLimit: string = "HELP_JACKPOT_VISIBLE_LIMIT";
    static DataHelpJackpotQualifyingBetsMin: string = "HELP_JACKPOT_QUALIFYING_BETS_MIN";
    static DataHelpJackpotQualifyingBetsMax: string = "HELP_JACKPOT_QUALIFYING_BETS_MAX";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Datas/GameData.ts
 **/